import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { api } from '../URL/api-url';
import Cookies from 'js-cookie';

@Injectable({
  providedIn: 'root'
})
export class ApiCommonService {

  constructor(private http: HttpClient) { }

  getHeaders() {
    let accessToken = sessionStorage.getItem('accessToken');
    let headers = {
      Authorization: 'Bearer ' + accessToken,
      'Content-Type': 'application/json',
    }
    return headers;
  }


  submitReportLog(obj: any, isSignIn: any = false) {
    console.log('submitReportLog', isSignIn);
    // system details
    let systemDetails = {
      platform: navigator.platform,
      language: navigator.language,
      screenWidth: window.screen.width,
      screenHeight: window.screen.height,
      userAgent: navigator.userAgent
    }
    obj.systemDetails = JSON.stringify(systemDetails);
    obj.browser = navigator.userAgent;
    obj.sessionDetails = JSON.stringify({ timestamp: sessionStorage.getItem('timeStamp') });
    if(isSignIn){
      console.log('singin api called')
      this.postSigninReportLog(obj);
      return;
    }

    try {
      this.http.post(
        api.commonLoginApiUrl + 'common/report/add-report',
        obj,
        { headers: this.getHeaders() }
      ).subscribe((response: any) => {
        if (response?.status == 200) {
          console.log('add report response 200', response);
        } else {
          console.log('add report response not 200', response);

          // hit signin api
          this.postSigninReportLog(obj);
        }
      })
    } catch (error) {
      console.error('error submitting report log', error)

      // hit signin api
      this.postSigninReportLog(obj);
    }
  }

  submitActivitytLog(obj: any) {
    try {
      this.http.post(
        api.commonLoginApiUrl + 'common/activity/add-activity',
        obj,
        { headers: this.getHeaders() }
      ).subscribe((response: any) => {
        if (response.status == 200) {
          console.log('add activity response 200', response);
        } else {
          console.log('add activity response not 200', response);
        }
      })
    } catch (error) {
      console.error('error submitting activity log', error)
    }
  }

  postAnalyticsData() {
    let pageName = sessionStorage.getItem("pageName")
    console.log(pageName);

    // Adding body or contents to send
    let body = JSON.stringify({
      "ipAddress": sessionStorage.getItem("ipaddress") ?? '',
      "timestamp": sessionStorage.getItem("timeStamp"),
      "pageName": pageName ? pageName : "Dashboard",
      "gbReferer": window.document.referrer || window.location.hostname || '',
      "pageUrl": window.location.href
    });

    // analytics
    this.http.post(
      api.url + "/analytics",
      body,
      { headers: { "Content-type": "application/json; charset=UTF-8" } }
    ).subscribe((result) => {
      console.log(result)
    })
  }

  getIpAddress() {
    // ip address
    try {
      this.http.get(
        "https://api.groupbenefitz.ca/api/admin/app2", {
        headers: {
          "Content-type": "application/json; charset=UTF-8"
        }
      }).subscribe((result: any) => {
        console.log(result)
        console.log(result.data.ip)
        setTimeout(() => {
          sessionStorage.setItem('ipaddress', result.data.ip)
          console.log('sessionIp 10', sessionStorage.getItem('ipaddress'))
        }, 10)
        setTimeout(() => {
          sessionStorage.setItem('ipaddress', result.data.ip)
          console.log('sessionIp 1000', sessionStorage.getItem('ipaddress'))
        }, 1000)
        setTimeout(() => {
          sessionStorage.setItem('ipaddress', result.data.ip)
          console.log('sessionIp 2000', sessionStorage.getItem('ipaddress'))
        }, 2000)
      })
    } catch (error) {
      console.log('error fetching ip address', error);
    }
  }

  getAndSubmitCookies(condition: string = '', submitReportLog: boolean = false, payload: any = {}) {
    const allCookies: Record<string, string> = Cookies.get() as Record<string, string>;
    const matchingCookies: Record<string, string> = {};

    // Filter and log cookies
    for (const [key, value] of Object.entries(allCookies)) {
      if (key.includes(condition)) {
        console.log(`Cookie -> ${key}: ${value}`);
        matchingCookies[key] = value;
      }
    }

    if (submitReportLog) {
      const obj = {
        customerDetails: JSON.stringify(payload),
        browser: '',
        systemDetails: {},
        logs: JSON.stringify(matchingCookies),
        sessionDetails: JSON.stringify({ timestamp: sessionStorage.getItem('timeStamp') })
      };

      this.submitReportLog(obj);

      // After submitting, remove only the matching cookies
      for (const key of Object.keys(matchingCookies)) {
        Cookies.remove(key);
      }
    }
  }

  getTimeStamp() {
    let currentTimeStamp = new Date().getTime().toString();
    return currentTimeStamp;
  }

  postSigninReportLog(obj: any) {
    this.http.post(
      api.signIn + 'common/report/add-report',
      obj
    ).subscribe((response: any) => {
      if (response.status == 200) {
        console.log('add report response 200', response);
      } else {
        console.log('add report response not 200', response);
      }
    })
  }

  getSessionStorageDetails() {
    const sessionStorageDetails: Record<string, string> = {};
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (key) {
        sessionStorageDetails[key] = sessionStorage.getItem(key) ?? '';
      }
    }

    return sessionStorageDetails;
  }
}
